import { render, staticRenderFns } from "./EcommerceCongratulationJohn.vue?vue&type=template&id=d196feac&scoped=true&"
var script = {}
import style0 from "./EcommerceCongratulationJohn.vue?vue&type=style&index=0&id=d196feac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d196feac",
  null
  
)

export default component.exports